export default "__VITE_ASSET__456e444f__"